<script setup>
import { ref,inject,onMounted,provide  } from 'vue'
import { ElMessage } from 'element-plus'
import axios from 'axios';
import { useMemberStore } from '../../stores';
const userStore = useMemberStore();
const size = ref('default')
const labelPosition = ref('right')
const headers = ref({
	'Authorization': `${userStore.profile?.token}`,
})

const sizeForm = ref({
	rq:'',
	cxh9:1,
	cxh7:1,
	cxs11:7,
	cxs5:0,
});
onMounted(()=>{
	
})
const onSubmit=async()=> {
	let isNull = false;
	Object.keys(sizeForm.value).forEach(key=>{
		if(sizeForm.value[key]===''){
			isNull = true;
		}
	})
	if(!isNull){
		const response = await axios.post('/manageCar/carCalendar/add', {
		  ...sizeForm.value
		}, {
		  headers: {
			'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			ElMessage.success('添加成功!')
			sizeForm.value = {}
		}
	}else{
		ElMessage.error('所有信息不可为空!')
	}
}
</script>
<template>
	<el-form
	    ref="form"
	    :model="sizeForm"
	    label-width="auto"
	    :label-position="labelPosition"
	    :size="size"
	>
		<div style="display: flex;">
			<el-form-item label="日期" style="width: 96%;">
			  <el-date-picker
				  v-model="sizeForm.rq"
				  type="date"
				  placeholder="请选择日期"
				  :size="size"
				/>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="豪华9" style="width: 48%;">
			  <el-input class="w-50 m-2" v-model="sizeForm.cxh9" />
			</el-form-item>
			<el-form-item label="豪华7" style="width: 48%;">
			  <el-input class="w-50 m-2" v-model="sizeForm.cxh7" />
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="舒适11" style="width: 48%;">
			  <el-input class="w-50 m-2" v-model="sizeForm.cxs11" />
			</el-form-item>
			<el-form-item label="舒5" style="width: 48%;">
			  <el-input  class="w-50 m-2" v-model="sizeForm.cxs5" />
			</el-form-item>
		</div>
		<div style="display: flex;justify-content: center;">
			<el-form-item>
		      <el-button type="primary" @click="onSubmit">保存</el-button>
		    </el-form-item>
		</div>
	</el-form>
</template>

<style scoped>
	.avatar-uploader .avatar {
	  width: 90px;
	  height: 90px;
	  display: block;
	}
	.avatar-uploader .el-upload {
	  border: 1px dashed var(--el-border-color);
	  border-radius: 6px;
	  cursor: pointer;
	  position: relative;
	  overflow: hidden;
	  transition: var(--el-transition-duration-fast);
	}
	
	.avatar-uploader .el-upload:hover {
	  border-color: var(--el-color-primary);
	}
	
	.el-icon.avatar-uploader-icon {
	  font-size: 28px;
	  color: #8c939d;
	  width: 90px;
	  height: 90px;
	  text-align: center;
	}
</style>